import { useEffect, useState } from "react";
import { InputReviewSearch, Review } from "@scrile/api-provider/dist/api/ReviewProvider";
import useAuthUser from "../../../../hooks/useAuthUser";
import providers from "../../../../lib/providers";
import { isPerformer } from "../../../../lib/usersHelper";

export default function useViewController(appointmentId?: string) {
  const { user } = useAuthUser();
  const [showReviewModal, setShowReviewModal] = useState(false);
  const [showFeedbackModal, setShowFeedbackModal] = useState(false);
  const [hasCoachFeedback, setHasCoachFeedback] = useState(false);
  const [loadingFeedback, setLoadingFeedback] = useState(false);

  const onShowReviewModal = () => setShowReviewModal(true);
  const onCloseReviewModal = () => setShowReviewModal(false);
  const onShowFeedbackModal = () => setShowFeedbackModal(true);
  const onCloseFeedbackModal = () => setShowFeedbackModal(false);

  const onFeedbackAdded = (_review: Review) => {
    setHasCoachFeedback(true);
  };

  useEffect(() => {
    if (!appointmentId || !isPerformer(user)) {
      setHasCoachFeedback(false);
      return;
    }

    let cancelled = false;
    setLoadingFeedback(true);
    Promise.resolve(
      providers.ReviewProvider.find({
        data: {
          subjects: [{ subjectId: appointmentId, subjectType: "appointment" as any }],
          size: 1,
        } as InputReviewSearch,
      })
    )
      .then((response) => {
        if (!cancelled) {
          setHasCoachFeedback(!!response?.result?.length);
        }
      })
      .catch(() => {
        if (!cancelled) {
          setHasCoachFeedback(false);
        }
      })
      .finally(() => {
        if (!cancelled) {
          setLoadingFeedback(false);
        }
      });

    return () => {
      cancelled = true;
    };
  }, [appointmentId, user]);

  return {
    showReviewModal,
    onShowReviewModal,
    onCloseReviewModal,
    showFeedbackModal,
    onShowFeedbackModal,
    onCloseFeedbackModal,
    hasCoachFeedback,
    loadingFeedback,
    onFeedbackAdded,
  };
}
